<script lang="ts">
  import { flagValue } from '$lib/context/flags';
  import { FEATURE_FLAGS } from '$lib/flags/constants';

  interface Props {
    open?: boolean;
    groupActive?: boolean;
  }

  let { open = false, groupActive = false }: Props = $props();

  let brandReskinEnabled = $derived(flagValue(FEATURE_FLAGS.BRAND_RESKIN));
</script>

<svg
  class:groupActive
  class:open
  class:reskin={brandReskinEnabled}
  height="100%"
  viewBox="0 0 36 36"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g clip-path="url(#clip0_1712_1441)">
    <path
      d="M35.5 18C35.5 27.665 27.665 35.5 18 35.5C8.33502 35.5 0.5 27.665 0.5 18C0.5 8.33502 8.33502 0.5 18 0.5C27.665 0.5 35.5 8.33502 35.5 18Z"
      stroke="currentColor"
      class="border"
    />
    <path class="transform-target" d="M18.0007 12V24" stroke="currentColor" stroke-width="1.5" />
    <path d="M12.0007 18L24.0007 18" stroke="currentColor" stroke-width="1.5" />
  </g>
  <defs>
    <clipPath id="clip0_1712_1441">
      <rect width="36" height="36" fill="white" />
    </clipPath>
  </defs>
</svg>

<style lang="scss">
  svg {
    overflow: visible;
  }

  svg.groupActive .border {
    stroke: var(
      --theme-button-secondary-button-hover-focus-foreground-color,
      var(--twist-color-gray-0)
    );
  }

  svg.groupActive.reskin .border {
    stroke: var(
      --theme-button-secondary-button-hover-focus-foreground-color,
      var(--twist-color-gray-25)
    );
  }

  svg path.transform-target {
    transform: rotate(0deg);
    transform-origin: 50% 50%;
    transition: transform var(--twist-duration-200) var(--twist-ease-out-1) var(--twist-duration-0);
  }

  svg.open path.transform-target {
    transform: rotate(90deg);
  }
</style>
